import React from "react";
import { ITabs } from "apps/website/components/feature/Tabs/shared/types";

import { RecipeContent } from "../components/RecipeContent";

export const recipeComparisonKatkinData: ITabs = {
  tabs: [
    {
      key: "1",
      title: "Cluck",
      Panel: {
        title: "100% fresh\n`Chicken`",
        Content: <RecipeContent imageKey="cluck" />,
        theme: "orange",
      },
    },
    {
      key: "2",
      title: "Gobble",
      Panel: {
        title: "100% fresh\n`Turkey`",
        subtitle: "+ Chicken",
        Content: <RecipeContent imageKey="gobble" />,
      },
    },
    {
      key: "3",
      title: "Mooo",
      Panel: {
        title: "100% fresh\n`Beef`",
        Content: <RecipeContent imageKey="mooo" />,
        theme: "orange",
      },
    },
    {
      key: "4",
      title: "Quack",
      Panel: {
        title: "100% fresh\n`Duck`",
        subtitle: "+ Chicken",
        Content: <RecipeContent imageKey="quack" />,
        theme: "green",
      },
    },
    {
      key: "5",
      title: "Baaa",
      Panel: {
        title: "100% fresh\n`Lamb`",
        Content: <RecipeContent imageKey="baaa" />,
        theme: "red",
      },
    },
    {
      key: "6",
      title: "Oink",
      Panel: {
        title: "100% fresh\n`Pork`",
        Content: <RecipeContent imageKey="oink" />,
        theme: "pink",
      },
    },
    {
      key: "7",
      title: "Splash",
      Panel: {
        title: "100% fresh\n`Fish`",
        subtitle: "+ Turkey",
        Content: <RecipeContent imageKey="splash" />,
        theme: "blue",
      },
    },
  ],
  defaultActiveTab: "1",
};
